export const name = 'translationsService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-translations' as const
